import axios from '../../../configs/axios';

export default {
  fetchCustomReports(filters, searchParams = '') {
    const { pagination, ...restFilters } = filters;
    const limit = parseInt(pagination.per_page, 10);
    const offset = parseInt(pagination.current_page, 10) * limit;

    return axios.get(`/custom_reports.json${searchParams}`, {
      params: {
        request: {
          assets: {
            custom_reports: {
              filters: { ...restFilters, limit, offset },
              assets: 'reports_list',
            },
          },
        },
      },
    });
  },
  fetchVersionData(customReportId, searchParams = '') {
    return axios.get(`/custom_reports.json${searchParams}`, {
      params: {
        request: {
          assets: {
            custom_reports_versions: {
              assets: ['versions_history'],
              filters: { custom_report_id: customReportId },
            },
          },
        },
      },
    });
  },
  subscribe(reportId) {
    return axios.post(`/custom_reports/${reportId}/create_recipient`, {});
  },
  unsubscribe(reportId) {
    return axios.delete(`/custom_reports/${reportId}/delete_recipient`);
  },
  updatePerPage(perPage) {
    return axios.post('/profile/update_options', {
      page_name: 'custom_reports',
      options: { per_page: perPage },
    });
  },
};
